"use client";
import { GoogleMapComponent } from "./googleMap";
import { OperatingHours } from "./operatingHours";
import { BusinessLocations } from "./businessLocations";
import { setKey, fromAddress } from "react-geocode";
import { useEffect, useState } from "react";
import { getTimezoneAbbreviation } from "@/utils/timeZoneAbbreviation";
import { Links } from "./links";
import { Address } from "@/dto/address";
setKey(process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY || "");

export type ShowLinks = {
  returnsAndExchangePolicy: boolean;
  termsOfUsePolicy: boolean;
};

export interface MerchantFooterProps {
  merchantName: string;
  merchantAddress: Address;
  merchantPhoneNumber: string;
  merchantEmail: string;
  facebookUrl?: string;
  instagramUrl?: string;
  businessHours: any;
  timezone: string;
  showLinks: ShowLinks;
  locale: string;
}

export const MerchantFooter = ({
  merchantName,
  merchantAddress,
  merchantPhoneNumber,
  merchantEmail,
  businessHours,
  facebookUrl,
  instagramUrl,
  timezone,
  showLinks,
  locale,
}: MerchantFooterProps) => {
  const [lat, setLat] = useState(0);
  const [long, setLong] = useState(0);
  useEffect(() => {
    fromAddress(createAddressString(merchantAddress))
      .then(({ results }) => {
        const { lat, lng } = results[0].geometry.location;
        setLat(lat);
        setLong(lng);
      })
      .catch(console.error);
  }, [merchantAddress]);

  const abbreviation = getTimezoneAbbreviation(timezone, locale);

  return (
    <div
      className={[
        "justify-between",
        "flex",
        "flex-wrap",
        "gap-[57px]",
        "px-12",
        "w-full",
        "items-start",
        "max-md:px-0",
        "max-md:flex-col",
        "py-[60px]",
        "bg-[#F8F8F8]",
      ].join(" ")}
    >
      <BusinessLocations
        {...{
          merchantName,
          merchantAddress,
          merchantPhoneNumber,
          merchantLocale: locale,
          merchantEmail,
          facebookUrl,
          instagramUrl,
        }}
      />
      <div
        className={[
          "w-[280px]",
          "h-[280px]",
          "max-md:ml-0",
          "max-md:w-full",
        ].join(" ")}
      >
        <div className={["flex", "justify-center"].join(" ")}>
          <GoogleMapComponent
            lat={lat}
            lng={long}
            height={"280px"}
            width={"280px"}
          />
        </div>
      </div>
      <OperatingHours
        {...{ daysOfWeek, businessHours }}
        timezone={abbreviation}
      />
      <Links {...{ showLinks }} />
    </div>
  );
};

export const daysOfWeek = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
];

export function createAddressString({
  address1,
  address2,
  address3,
  city,
  state,
  zip,
  country,
}: Address) {
  return [address1, address2, address3, city, state, zip, country].join(", ");
}
